<template>
    <li>
        <button
            @click="toggleIsEditingDetails"
            :aria-expanded="isEditingDetails"
            class="bg-v2-white border border-v2-white flex font-medium gap-3 items-center leading-none max-w-full p-3 relative rounded text-v2-gray-20 text-left text-xs w-full hover:border-v2-gray-70 dark:bg-v2-gray-65 dark:border-v2-gray-10 dark:text-v2-gray-130 hover:dark:border-v2-gray-90 hover:dark:text-v2-white"
        >
            <BaseSvg
                name="Edit"
                :aria-hidden="!isEditingDetails"
                class="fill-v2-gray-70 shrink-0 size-4 dark:fill-v2-gray-90"
            />
            Edit details
            <BaseSvg
                :name="isEditingDetails ? 'ExpandLess' :'ExpandMore'"
                :aria-hidden="!isEditingDetails"
                class="fill-v2-gray-70 ml-auto shrink-0 size-5 dark:fill-v2-gray-90"
            />
        </button>
        <form v-if="isEditingDetails"
              class="bg-v2-white -mt-1 p-3 rounded-b dark:bg-v2-gray-65 dark:border dark:border-v2-gray-10 dark:border-t-0 dark:relative">
            <fieldset class="flex flex-col gap-2">
                <label for="tray-name" class="sr-only">Tray name</label>
                <input
                    type="text"
                    name="tray-name"
                    ref="isEditingTrayNameInput"
                    id="tray-name"
                    class="border-v2-blue py-1 rounded text-xs dark:bg-v2-gray-40"
                    v-model="newNameInput"
                    placeholder="Tray name"
                />
                <label for="tray-description" class="sr-only">Tray description (optional)</label>
                <textarea
                    v-model="newDescriptionInput"
                    name="tray-description"
                    id="tray-description"
                    class="border-v2-gray-110 min-h-20 py-1 rounded text-xs dark:bg-v2-gray-40 dark:border-v2-gray-10"
                    placeholder="Tray description (optional)"
                ></textarea>
            </fieldset>
            <div class="mt-2 text-right">
                <button
                    @click.prevent="handleUpdate"
                    type="button"
                    :disabled="isLoading || (newNameInput === tray.name && newDescriptionInput === tray.description)"
                    class="disabled:opacity-50 disabled:pointer-events-none bg-v2-white border border-v2-gray-110 font-medium leading-none px-4 py-2 rounded text-v2-gray-20 text-xs hover:bg-v2-gray-130 dark:bg-v2-gray-40 dark:border-v2-gray-10 dark:text-v2-white dark:hover:bg-v2-gray-70"
                >
                    <LoadingCircle v-if="isLoading" />
                    <span v-else>Update</span>
                </button>
            </div>
        </form>
    </li>
</template>

<script setup>
import {nextTick, ref, onMounted, onUnmounted} from "vue";
import {usePinsDrawer, eventBus} from "@/Composables";
import {LoadingCircle} from "@/Components";

const props = defineProps(['tray']);
const { updateTray, isLoading } = usePinsDrawer();

const isEditingDetails = ref(false);
const newNameInput = ref(props.tray.name);
const newDescriptionInput = ref(props.tray.description);
const isEditingTrayNameInput = ref();

function toggleIsEditingDetails() {
    isEditingDetails.value = !isEditingDetails.value;
    nextTick(() => {
        isEditingTrayNameInput.value?.focus();
    });
}

async function handleUpdate() {
    await updateTray(props.tray.id, newNameInput.value, newDescriptionInput.value);
    if (!isLoading.value) {
        isEditingDetails.value = false;
    }
}

function onTrayUpdated(tray) {
    if (tray.id === props.tray.id) {
        newNameInput.value = tray.name;
        newDescriptionInput.value = tray.description;
        isEditingDetails.value = false;
    }
}

onMounted(() => {
    eventBus.on('pins:tray-updated', onTrayUpdated);
});

onUnmounted(() => {
    eventBus.off('pins:tray-updated', onTrayUpdated);
});
</script>
